import React, { useState } from 'react';
import styles from './ccf-acd-header.module.scss';
import Badge from '@mui/material/Badge';
import {
  AppBar,
  Toolbar,
  IconButton,
  Grid,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
} from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';
import PersonIcon from '@mui/icons-material/Person';
// import CcfAgentState from '../ccf-agent-state/ccf-agent-state';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import {
  CcfAcdIcon,
  CcfAdminIcon,
  CcfAnalyticsIcon,
  CcfAvatar,
  CcfBox,
  CcfCxoneIcon,
  CcfMaxIcon,
  CcfReportingIcon,
  CcfSupervisorIcon,
  CcfTypography,
  CcfUpArrowIcon,
  CcfWfiIcon,
  CcfFavDashboardIcon,
  CcfHelpIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { selectLoginCredentialsState } from '../login/+state/login.slice';
import { useDispatch, useSelector } from 'react-redux';
import CcfAcdHeaderPopover from './ccf-acd-header-popover';
import { globalActions } from '../global.app.slice';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { isEternalsEnv } from '../../util/common';

/* eslint-disable-next-line */
export interface CcfAcdHeaderProps {}

/**
 * Component displays App header on landing screen
 * @param props -CcfAcdHeaderProps
 * @returns app header component for landing screen
 * @example <CcfAcdHeader/>
 */
export function CcfAcdHeader(props: CcfAcdHeaderProps) {
  const [count, setCount] = useState(2);
  const [translate] = useTranslator();
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();
  const loginCredentials = useSelector(selectLoginCredentialsState);
  const loginCredentialsFromSSO = accounts[0]?.name || ' ';
  const loginCredentialsArray = loginCredentialsFromSSO?.split(' ');
  const initials = isAuthenticated
    ? loginCredentialsArray[0].charAt(0).toUpperCase() +
      loginCredentialsArray[1].charAt(0).toUpperCase()
    : loginCredentials.firstName.charAt(0).toUpperCase() +
      loginCredentials.lastName.charAt(0).toUpperCase();
  const { renderVoicePrefPage, setAuthenticationStage } = globalActions;
  const dispatch = useDispatch();
  // const currentURL = window.location.href;
  // const agentDemoTestURL = 'https://d1s74gzjhz7gu0.cloudfront.net/home';
  // const agentDemoProdURL = 'https://d1u959wi0vug3n.cloudfront.net/home';
  // const isTestEnvironment = currentURL === agentDemoTestURL;
  // const isProdEnvironment = currentURL === agentDemoProdURL;
  // const supervisorDemoTestURL = 'https://dcurjblvs5238.cloudfront.net/home';
  // const supervisorDemoProdURL = 'https://d1h1wcoo8hfl5i.cloudfront.net/home';

  /**
   *
   * @example
   */
  const setNavigation = (text: string, index: number) => {
    if (text.startsWith('CXone') && index === 1) {
      //route to cxone agent
      if(!isEternalsEnv()){
      dispatch(setAuthenticationStage(2));
      }
      if(localStorage.getItem('voicePreferenceRememberOption')){  
        dispatch(renderVoicePrefPage(false));
      }
      else {
        dispatch(renderVoicePrefPage(true));
      }
    }
    if (text === 'Patron') {
      //route to patron
      window.open('/patron');
    }
    //  else if (text === 'Supervisor') {
    //   //route to supervisor URL based on current Environment
    //   if (isTestEnvironment) {
    //     window.location.href = supervisorDemoTestURL;
    //   } else if (isProdEnvironment) {
    //     window.location.href = supervisorDemoProdURL;
    //   } else {
    //     window.location.href = 'http://localhost:3000/home'; // run supervisor application on port 3000
    //   }
    // }
  };

  const [showPopOver, setShowPopOver] = useState(false);
  const [popoverFeature, setPopoverFeature] = useState('');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [state, setState] = React.useState({ left: false });

  /**
   *
   * @param anchor  - any
   * @param open - any
   * @returns
   * @example
   */
  const toggleDrawer = (anchor: any, open: any) => (event: any) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  /**
   *
   * @param anchor - event
   * @param open - boolean
   * @returns
   * @example
   */
  const list = (anchor: any) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <div className={styles.appForList}>
          <AppsIcon className={styles.appsIconForList} />
          <CcfTypography className={styles.grpHeadingListItem}>
            {translate('applications')}
          </CcfTypography>
        </div>

        <Divider />
        <div className={styles.listGroup}>
          <CcfTypography className={styles.grpHeadingListItem}>
            {translate('GENERAL')}
          </CcfTypography>
          {[translate('admin'), translate('supervisor')].map((text, index) => (
            <ListItem button key={text}>
              <ListItemIcon>
                {index % 2 === 0 ? (
                  <CcfAdminIcon viewBox="0 0 30 30" />
                ) : (
                  <CcfSupervisorIcon viewBox="0 0 38.859 42.95" />
                )}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </div>
        <Divider />
        <div className={styles.listGroup}>
          <CcfTypography className={styles.grpHeadingListItem}>
            {translate('OMNICHANNELROUTING')}
          </CcfTypography>
          {[translate('ACD'), translate('CXoneAgent'), translate('Patron')].map((text, index) => (
            <ListItem
              button
              key={text}
              onClick={() => setNavigation(text, index)}
            >
              <ListItemIcon>
                {text === 'Patron' ? (
                  <PersonIcon />
                ) : text === 'ACD' ? (
                  <CcfAcdIcon viewBox="0 0 30 30" />
                ) : (
                  <CcfMaxIcon viewBox="0 0 30 30" />
                )}
              </ListItemIcon>
              <ListItemText
                id={
                  text === 'ACD'
                    ? 'ACD'
                    : text === 'Cxone Agent'
                    ? 'cxoneAgent'
                    : 'Patron'
                }
                primary={text}
              />
            </ListItem>
          ))}
        </div>
        <Divider />
        <div className={styles.listGroup}>
          <CcfTypography className={styles.grpHeadingListItem}>
            {translate('DATAANALYTICS')}
          </CcfTypography>
          {[translate('Analytics'), translate('Reporting')].map(
            (text, index) => (
              <ListItem button key={text}>
                <ListItemIcon>
                  {index % 2 === 0 ? (
                    <CcfAnalyticsIcon viewBox="0 0 30 30" />
                  ) : (
                    <CcfReportingIcon viewBox="0 0 30 30" />
                  )}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItem>
            )
          )}
        </div>
        <Divider />
        <div className={styles.listGroup}>
          <CcfTypography className={styles.grpHeadingListItem}>
            {translate('AUTOMATION')}
          </CcfTypography>
          {[translate('WFI')].map((text, index) => (
            <ListItem button key={text}>
              <ListItemIcon>
                <CcfWfiIcon viewBox="0 0 30 30" />
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </div>
      </List>
    </Box>
  );

  /**
   * @example handleClose()
   */
  const handleClose = () => {
    setAnchorEl(null);
    setShowPopOver(false);
  };

  return (
    <>
      {showPopOver && (
        <CcfAcdHeaderPopover
          popoverFeature={popoverFeature}
          anchorEl={anchorEl}
          handleClose={handleClose}
        />
      )}
      <AppBar position="static" className={styles.header}>
        <Grid
          container
          style={{
            flexWrap: 'nowrap',
          }}
        >
          <Grid item lg={6} md={6} sm={6} xs={6}>
            <Toolbar
              className="toolbar"
              style={{ justifyContent: 'flex-start' }}
            >
              <IconButton
                edge="start"
                color="inherit"
                aria-label="apps"
                className="zeroBorderRadius"
              >
                <div className="appsIconWithChannel">
                  <React.Fragment key={'left'}>
                    <AppsIcon
                      id="appLauncher"
                      onClick={toggleDrawer('left', true)}
                      className="appsIcon"
                    ></AppsIcon>

                    <Drawer
                      anchor={'left'}
                      open={state['left']}
                      onClose={toggleDrawer('left', false)}
                    >
                      {list('left')}
                    </Drawer>
                  </React.Fragment>
                </div>
              </IconButton>
              <CcfAcdIcon />
              <CcfTypography style={{ paddingLeft: '20px', color: 'white' }}>
                ACD
              </CcfTypography>
            </Toolbar>
          </Grid>
          <CcfBox className="cxoneLogo">
            <CcfCxoneIcon style={{ width: '60px', height: '56px' }} />
          </CcfBox>

          <Grid item lg={6} md={6} sm={6} xs={6}>
            <Toolbar className="toolbar">
              <IconButton
                color="inherit"
                aria-label="Dashboard"
                className="zeroBorderRadius"
              >
                <CcfHelpIcon className="notificationsOutlinedIcon" />
              </IconButton>
              <IconButton
                color="inherit"
                aria-label="Dashboard"
                className="zeroBorderRadius dashboardAlignment"
                onClick={(e: any) => {
                  setShowPopOver(true);
                  setPopoverFeature('Dashboard');
                  setAnchorEl(e?.currentTarget);
                }}
              >
                <CcfFavDashboardIcon className="notificationsOutlinedIcon" />
              </IconButton>
              <IconButton
                color="inherit"
                aria-label="Notifications"
                className="zeroBorderRadius notificationAlignment"
                onClick={(e: any) => {
                  setShowPopOver(true);
                  setPopoverFeature('Notification');
                  setAnchorEl(e?.currentTarget);
                }}
              >
                <Badge
                  badgeContent={count}
                  classes={{
                    badge: 'notificationBadge',
                  }}
                >
                  <NotificationsNoneIcon className="notificationsOutlinedIcon" />
                </Badge>
              </IconButton>
              <div
                color="inherit"
                aria-label="agent state"
                className="userProfile"
                onClick={(e: any) => {
                  setShowPopOver(true);
                  setPopoverFeature('User Profile');
                  setAnchorEl(e?.currentTarget);
                }}
              >
                <CcfAvatar
                  alt={initials}
                  height={24}
                  width={24}
                  className="avatarHeader"
                >
                  {initials}
                </CcfAvatar>
                <CcfUpArrowIcon className="upArrowIcon" />
              </div>
            </Toolbar>
          </Grid>
        </Grid>
      </AppBar>
    </>
  );
}

export default CcfAcdHeader;
